import { render, staticRenderFns } from "./decription.vue?vue&type=template&id=7ad8d022&scoped=true&"
import script from "./decription.vue?vue&type=script&lang=js&"
export * from "./decription.vue?vue&type=script&lang=js&"
import style0 from "./decription.vue?vue&type=style&index=0&id=7ad8d022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad8d022",
  null
  
)

export default component.exports